import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; }
    catch { setUser(false); return null; }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const store = (token, remember) => {
    if (!token) return;
    if (remember) localStorage.setItem("token", token);
    else sessionStorage.setItem("token", token);
  };

  const login = async (email, password, remember = true) => {
    const { data } = await api.post("/auth/login", { email, password });
    store(data.token, remember); setUser(data.user); return data.user;
  };
  const register = async (email, password, name, remember = true) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    store(data.token, remember); setUser(data.user); return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token"); sessionStorage.removeItem("token"); setUser(false);
  };
  const patchUser = (patch) => setUser((u) => (u ? { ...u, ...patch } : u));

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser, patchUser }}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
